export enum DateFormat {
  MM_DD_YYYY_SLASHED = "MM/DD/YYYY",
  MMM_DD_YYYY = "MMM DD YYYY",
  MM_DD_YYYY_TIME = "MM/DD/YYYY, h:mm A",
}

export enum TimeTypes {
  DAY = "day",
}
